/**
 * Module dependencies.
 */

import getConfig from 'next/config';

/**
 * Export `getAdminEndpoint`.
 */

export function getAdminEndpoint() {
  return (
    getConfig().serverRuntimeConfig.directusEndpoint ??
    getConfig().publicRuntimeConfig.directusEndpoint
  );
}

/**
 * Export `getAsset`.
 */

export function getAsset(file, options?: any) {
  const queryString = new URLSearchParams(options ?? {}).toString();

  return `${getAdminEndpoint()}/assets/${file}?${queryString}`;
}

/**
 * Export `getGrapghqlEndpoint`.
 */

export function getGrapghqlEndpoint() {
  return `${getAdminEndpoint()}/graphql`;
}
